"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const alchemy_ui_1 = require("@m/alchemy-ui");
const HorizontalStack_1 = __importDefault(require("@mdigital/components/dist/components/HorizontalStack"));
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const utils_1 = require("../../../common/utils");
const utils_2 = require("../../common/utils");
const TextPathPrefix = `app.pages.forms.builder.tabs.fieldSettings.conditionalDisplayModal`;
const CopyToClipboardText = `${TextPathPrefix}.copyToClipboard`;
const CopiedText = `${TextPathPrefix}.copied`;
const StyledInfoboxWrapper = styled_components_1.default.div `
  flex-grow: 1;
  border-radius: ${(0, alchemy_ui_1.borderRadius)('extraLarge')};
  background-color: ${(0, alchemy_ui_1.color)("hint")};
  border: 1px solid ${(0, alchemy_ui_1.color)("highlight")};
  color: ${(0, alchemy_ui_1.color)("contrast")};
  min-height: ${(0, alchemy_ui_1.units)(4)};
  position: relative;
  padding: ${(0, alchemy_ui_1.units)(0.5)} ${(0, alchemy_ui_1.units)(2)} ${(0, alchemy_ui_1.units)(0.5)} ${(0, alchemy_ui_1.units)(2)};
  overflow: hidden;
`;
const StyledInfoboxContent = styled_components_1.default.div `
  overflow: hidden;
  overflow-x: auto;
  white-space: nowrap;
  -ms-overflow-style: none;
  scrollbar-width: none; 
  &::-webkit-scrollbar {
    display: none;
  }
`;
const StyledCopiedMessage = styled_components_1.default.div `
  position: absolute;
  right: ${(0, alchemy_ui_1.units)(0.5)};
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
`;
exports.default = (props) => {
    const timerRef = (0, react_1.useRef)(undefined);
    const theme = (0, styled_components_1.useTheme)();
    const [copied, setCopied] = (0, react_1.useState)(false);
    const wrapper = (0, react_1.useRef)(null);
    const copy = (0, react_1.useCallback)(() => {
        (0, utils_2.copyToClipboard)(props.text, wrapper.current);
        setCopied(true);
        window.clearTimeout(timerRef.current);
        timerRef.current = window.setTimeout(() => {
            setCopied(false);
        }, 5000);
    }, [wrapper, props.text]);
    (0, react_1.useEffect)(() => {
        return () => clearTimeout(timerRef.current);
    }, []);
    const pillBorderProps = {
        theme,
        colorScheme: "alchemyBrand",
        palette: 'structural'
    };
    const pillBorderColor = (0, alchemy_ui_1.color)("highlight", { palette: "interactiveConstructive" })(pillBorderProps);
    return (react_1.default.createElement(HorizontalStack_1.default, { gap: (0, alchemy_ui_1.units)(2) },
        react_1.default.createElement(StyledInfoboxWrapper, null,
            react_1.default.createElement(StyledInfoboxContent, null, props.text),
            copied && (react_1.default.createElement(StyledCopiedMessage, null,
                react_1.default.createElement(alchemy_ui_1.Pill, { style: { borderColor: pillBorderColor }, palette: "expressiveInformative" }, (0, utils_1.getSingleText)(CopiedText))))),
        react_1.default.createElement(alchemy_ui_1.IconButton, { ref: wrapper, palette: "interactiveConstructive", icon: react_1.default.createElement(alchemy_ui_1.CopyIcon, { "aria-hidden": "true" }), tooltipContents: (0, utils_1.getSingleText)(CopyToClipboardText), onClick: copy, disabled: props.text == null || !props.text.trim().length })));
};
